import { useParams } from 'react-router';
import { TopBar } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';

export const UserHistoryBar = () => {
  const { formatMessage } = useLocale();
  const { id } = useParams<{ id: string }>();

  const isUserHistoryView = useIsExactPath(AppRouteWithParams.userHistory.path);
  const isUserPermissionsHistoryView = useIsExactPath(AppRouteWithParams.userPermissionsHistory.path);

  return (
    <TopBar gridTemplateColumns="auto auto 1fr">
      <TopBar.Link linkTo={AppRouteWithParams.userHistory.get({ id: id || '' })} isActive={isUserHistoryView}>
        {formatMessage({ id: AppMessages['user.history.user'] })}
      </TopBar.Link>

      <TopBar.Link
        linkTo={AppRouteWithParams.userPermissionsHistory.get({ id: id || '' })}
        isActive={isUserPermissionsHistoryView}
      >
        {formatMessage({ id: AppMessages['user.history.permissions'] })}
      </TopBar.Link>

      <TopBar.EmptyBarWithLine />
    </TopBar>
  );
};
